<template>
    <page-container2 :title="formTitle" useCard>
        <template v-slot:buttons>
            <el-button type="primary" size="mini" @click="save">保存</el-button>
        </template>
        <permission-container :permissionId="permissionId" showTip>
        <el-form ref="form" :model="form" v-loading="loading" status-icon :rules="rules" label-suffix =":" label-width="100px">
            <el-form-item label="客户名称" prop="name">
                <el-input v-model="form.name" autocomplete="off" class="one-third-width" placeholder="请输入客户名称" ></el-input>
            </el-form-item>
            <el-form-item label="客户编码" prop="code">
                <el-input v-model="form.code" autocomplete="off" class="one-third-width" placeholder="请输入客户编码"></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="contacts">
                <el-input v-model="form.contacts" autocomplete="off" class="one-third-width" placeholder="请输入联系人" ></el-input>
            </el-form-item>
            <el-form-item label="联系手机号" prop="phone">
                <el-input v-model="form.phone" autocomplete="off" class="one-third-width" placeholder="请输入联系手机号" ></el-input>
            </el-form-item>
            <el-form-item label="账单日" prop="billDay">
                <span style="display: flex;">
                    每个月<el-select v-model="form.billDay" placeholder="请选择出账日" style="width: 130px;margin: 0px 10px;">
                            <el-option
                            v-for="day in dayList"
                            :key="day"
                            :label="day"
                            :value="day">
                            </el-option>
                        </el-select>日，自动生成对账单
                </span>
            </el-form-item>
            <el-form-item label="客户备注" prop="remark">
                <el-input type="textarea" v-model="form.remark" class="half-width"
                          placeholder="请输入客户备注"
                          :rows="4"
                          maxlength="64"
                          show-word-limit
                ></el-input>
            </el-form-item>
            
        </el-form>
        </permission-container>
    </page-container2>
</template>

<script>
function isArrayItemEquals(arr1, arr2) {
    if(!arr1 || !arr2) return false;
    if(arr1.length != arr2.length) return false;
    for(let v of arr1) {
        if(!arr2.find((a2v)=>a2v==v)) {
            return false;
        }
    }
    return true;
}
export default {
    name: "CustomerEdit",
    data()
    {
        return {
            form: {
                id: 0,
                name: '',
                code: '',
                contacts: '',
                phone: '',
                remark: '',
                billDay: null
            },
            rules: {
                name: [
                    { required: true, message: '请输入客户名称', trigger: 'blur' },
                ],
                code: [
                    { required: true, message: '请输入客户编码', trigger: 'blur' },
                    {
                        validator: this.checkCode,
                        trigger: 'blur'
                    }
                ]
            },
            loading: false,
            permissionId: "Erp.Customer.Add",
            formTitle: "添加客户",
            dayList:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28]
        };
    },
    mounted()
    {
        // console.log('user edit mounted.', this.$route.query);
        return Fx.Promise.then(()=>
        {
            if(this.$route.query && this.$route.query.id)
            {
                this.permissionId = "Erp.Customer.Edit";
                this.formTitle = "编辑客户";
                this.form.id = this.$route.query.id;
                return this.loadCustomer();
            }
        });

    },
    methods: {
        loadCustomer() {
            if(!this.form.id) return Fx.Promise.resolve(true);
            return Fx.Http.post("/customer/get", {id: this.form.id}).
            then((response)=>
            {
                console.log('get resp', response);
                if(response.isSuccess())
                {
                    this.form.id = response.getData("id");
                    this.form.name = response.getData("name");
                    this.form.code = response.getData("code");
                    this.form.contacts = response.getData("contacts");
                    this.form.phone = response.getData("phone");
                    this.form.remark = response.getData("remark");
                    this.form.billDay = response.getData("billDay");
                    return true;
                } else {
                    this.showMessageError('加载客户数据失败：' + response.getErrorMessage());
                    return false;
                }
            });
        },
        checkCode(rule, value, callback){
            return Fx.Http.post("/customer/checkCode", {id: this.form.id, code: this.form.code}).
            then((resp)=>
            {
                if(resp.isSuccess()) {
                    callback();
                } else {
                    callback(new Error(resp.getErrorMessage()));
                }
            })
        },
        
        save()
        {
            console.log(this.form);
            return new Promise((resolve, reject)=>{
                this.$refs.form.validate(valid =>
                {
                    if(!valid) {
                        resolve(false);
                        return;
                    }
                    this.loading = true;
                    let savePath = "/customer/save";
                    return Fx.Http.post(savePath, Fx.mergeDeep(this.form)).
                    then((resp)=>
                    {
                        this.loading = false;
                        if(resp.isSuccess())
                        {
                            this.form.id = resp.getData('id');
                            this.showMessageSuccess('保存成功');
                            return this.loadCustomer();
                        }
                        else
                        {
                            this.showMessageError('保存客户失败:'+resp.getErrorMessage());
                            return false;
                        }
                    }).
                    then(result=>resolve(result));
                });
            })
        },
        
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/modules/erp/pages/customer/Edit.vue